import React from 'react'

export default function Footer() {
    return (
        <div className="py-3 bg-black">
            <div className="text-base md:text-lg text-white text-center ">©2021 Design & Developed By | <a href="https://teamportfolios.netlify.app/">Ashish Kumar Mishra</a>  | All Rights Reserved.</div>
        </div>
    )
}
